// This store strictly controls which document should be in a viewing mode.
// IMO this is an unoptimal solution and the viewstate should be handled within redux
// store in the redux component tree. However, that requires partial rewrite of
// document state management as the toolbar is too high in the tree at the moment.

import createReducer from 'lib/createReducer';

/* Action types */

const SET_VIEW_ID = 'mystellarq/viewstate/SET_VIEW_ID';
const CLEAR_VIEW_ID = 'mystellarq/viewstate/CLEAR_VIEW_ID';

export const actionTypes = { SET_VIEW_ID, CLEAR_VIEW_ID };

/* Action creators */

/**
 * Set document ID as currently viewed for a doctype
 * @param {string} documentType Document type
 * @param {string} documentId Document ID
 * @returns {object} Dispatchable action
 */
const setViewId = (documentType, documentId) => ({
  type: SET_VIEW_ID,
  meta: { documentType },
  payload: documentId,
});

/**
 * Clear view id from a document type
 * @param {string} documentType Document type
 * @returns {object} Dispatchable action
 */
const clearViewId = documentType => ({
  type: SET_VIEW_ID,
  meta: { documentType },
});

export const actions = { setViewId, clearViewId };

const initialState = {};

const handleSetViewId = (s, a) => ({ ...s, [a.meta.documentType]: a.payload });

const handleClearViewId = (s, a) => ({ ...s, [a.meta.documentType]: null });

export default createReducer(initialState, {
  [SET_VIEW_ID]: handleSetViewId,
  [CLEAR_VIEW_ID]: handleClearViewId,
});
